import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private snackBar: MatSnackBar) { }

  success(message: string, duration: any) {
    const time = duration != null && duration >= 0 ? duration : 3000;
    this.snackBar.open(message, 'close', {
      duration: time
    });
  }

  error(message: string, duration = null, horizontal?: undefined, vertical?: undefined) {
    const time = duration != null && duration >= 0 ? duration : 2000;
    this.snackBar.open(message, 'close', {
      duration: time
    });
  }
}
